export enum SortingTypes {
  ASC = "ASC",
  DESC = "DESC",
}